export class RestoreAzureVmNativeRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "recoveryPointId",
            "baseName": "recoveryPointId",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultName",
            "baseName": "vaultName",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultResourceGroup",
            "baseName": "vaultResourceGroup",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAzureVmNativeRequest.attributeTypeMap;
    }
    constructor() {
    }
}
